module.exports = __webpack_public_path__ + "static/media/upb.9e216f2b.png";